// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root_1K4UF","active":"index_active_ikoX7","feedback":"index_feedback_2MFsj","loading":"index_loading_JdbGA"};